import { Fragment, useEffect, useState } from 'react';
import { IPage, registerPage } from '../Components/Page';
import Home from './Home';
import SearchIcon from '@mui/icons-material/Search';
import { formatDate, useInitAsync } from '../Utils';
import SearchText from '../Components/SearchText';
import { eventStore, IStoreEvent } from '../Services/EventsStore';
import Button from '@mui/material/Button';
import session from '../Services/Session';
import { ReactComponent as EventsIcon } from '../Images/events.svg';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import { useNetwork, useOnlineCheck } from '../Hooks/Network';
import { useActions } from '../Hooks/Actions';
import "./EventList.scss"
import { IUserSettings, userSettingsStore } from '../Services/UserSettingsStore';
import lmApiClient from '../Services/LmApiClient';
import { appSettings } from '../AppSettings';
import { useOperation } from '../Hooks/OperationContext';
import Settings from './Settings';
import useAppBar from '../Hooks/AppBarContext';
import { useLocation } from 'react-router';

interface IEventListProps {
    events?: IStoreEvent[];
}

function EventListContent(props: IEventListProps) {

    const network = useNetwork();

    const actions = useActions();

    const operation = useOperation();

    const [events, setEvents] = useState(props.events);

    const [activeEvents, setActiveEvents] = useState(props.events);

    const onlineCheck = useOnlineCheck();

    const setAppBar = useAppBar();

    const location = useLocation();

    const isAutoSelect = location.state?.autoSelect;

    console.log(location);

    useInitAsync(async () => {

        if (!await actions.verifyApiUrlAsync()) {
            operation.showErrorAsync("Nessun endpoint configurato per connettersi al servizio, assicurarsi che la connessione internet sia attiva e che si disponga di una licenza valida.")
            //TODO and now?
        }

        if (!events && session?.pin) {
            const result = await network(() => eventStore.listEventsAsync());
            result?.sort((a, b) => a.date.getTime() - b.date.getTime());
            setEvents(result);
            setActiveEvents(result);
        }

        session.activeEvent = null;
        session.activeGate = null;

        await onlineCheck();

    });


    const search = text => {
        const result = text ? events.filter(a => a.title.toLowerCase().indexOf(text.toLowerCase()) != -1) : events;
        setActiveEvents(result);
    };

    const onEventSelected = async (ev: IStoreEvent) => {
        session.activeEvent = ev;
        session.activeGate = null;

        await network(async () => {
            try {
                await lmApiClient.sendUsageStatsAsync({
                    deviceId: session.deviceId,
                    event: {
                        ntcId: parseInt(ev.id),
                        ntcSystemUrl: appSettings.apiUrl,
                        eventTitle: ev.title,

                    }
                })
            }
            catch (ex) {
               console.warn("Usage stats", ex);
            }
        });

        if (userSettingsStore.current.monitorMode)
            actions.openMonitorAsync(ev.id);
        else
            actions.scanOrCountAsync(ev.id);
    }

    useEffect(() => {
        if (activeEvents && activeEvents.length == 1 && isAutoSelect)
            onEventSelected(activeEvents[0]);

    }, [activeEvents]);


    useEffect(() => {

        setAppBar({
            backVisible: false,
            actions: [
                {
                    body: Settings.title,
                    icon: Settings.icon,
                    executeAsync: async () => actions.settings()
                }
            ]
        });

    },[]);


    return (
        <Fragment>
            <div className="search-box">
                <SearchIcon />
                <SearchText placeholder="Cerca..." onChanged={text => search(text)} />
            </div>
            {(activeEvents && activeEvents.length == 0) ?
                <div className="empty-list">
                    <EventBusyIcon />
                    <span>Nessun evento attivo</span>
            </div>
            :
            <div className="list-view">
                {activeEvents?.map((a, i) => {

                    let status = "active";

                    return (
                        <div key={i} className="list-item" onClick={() => onEventSelected(a)}>
                            <div className="main">
                                <header>{formatDate(a.date)}</header>
                                <div className="body">{a.title}</div>
                            </div>
                            <div className={"status " + status}>
                                <span className="red">⬤</span>
                                <span className="yellow">⬤</span>
                                <span className="green">⬤</span>
                            </div>
                        </div>
                    );
                })}
            </div >
            }
            <Button variant="contained" className="change-pin" size="large" onClick={() => actions.login()}>Cambia pin</Button>
        </Fragment >
    );
}

const EventList: IPage = {

    name: "event-list",
    title: "Eventi",
    route: "/events",
    icon: <EventsIcon />,
    content: <EventListContent />,
    container: Home
}

registerPage(EventList);

export default EventList;

